import React, { Component } from 'react';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { EVENT_ID, getUserID, SURVEY_API_URL, USER_API_URL } from '../../constants';
import axios from 'axios';
import QuizDialog from './QuizDialog';
import QuizResDialog from './QuizResDialog';
import swal from 'sweetalert';
import { BsPencilSquare } from 'react-icons/bs';
import cloneDeep from 'lodash/cloneDeep';

import moment from 'moment';

// import cloneDeep from 'lodash/cloneDeep';

class QuizButton extends Component {
  constructor(props) {
    super(props);
    // const arrQuiz = [
    //   {
    //     quizSession: 'Musculoskeletal Ultrasound Workshop I - Advance Course (KOR)',
    //     polls: [
    //       'evt002_poll001',
    //       'evt002_poll002',
    //       'evt002_poll003',
    //       'evt002_poll004',
    //       'evt002_poll005',
    //       'evt002_poll006',
    //       'evt002_poll007',
    //       'evt002_poll008',
    //       'evt002_poll009',
    //     ],

    //     quizNo: ['Quiz1', 'Quiz2', 'Quiz3', 'Quiz4', 'Quiz5', 'Quiz6', 'Quiz7', 'Quiz8', 'Quiz9'],
    //     answer: [0, 1, 2, 2, 2, 2, 1, 4, 4],
    //   },
    // ];

    this.state = {
      ItemList: [],
      openQuiz: false,
      openResult: false,
      quizIdx: 0,
      quizCnt: 0,
      quizRemain: 3,
      quizScore: 0,
      // arrQuiz: arrQuiz,
      now: new Date(),
    };

    this.closeQuiz = this.closeQuiz.bind(this);
    this.showQuiz = this.showQuiz.bind(this);
    this.checkMySubmit = this.checkMySubmit.bind(this);
  }

  componentDidMount() {
    this.checkMySubmit();
    try {
      axios
        .get(`${SURVEY_API_URL}/polls/?eventId=${EVENT_ID}&channel=${this.props.channel}`, { headers: { Pragma: 'no-cache' } })
        .then((res) => {
          console.log('QUIZ', res.data);
          let count = []; // eslint-disable-next-line
          res.data.Items.map((item) => {
            if (!count.includes(item.sessionNo)) {
              count.push(item.sessionNo);
            }
          });

          this.setState({
            ItemList: count,
            datas: res.data.Items,
          });
          console.log(this.state.ItemList);
          console.log(this.state.datas);
        });
    } catch (e) {
      console.error(e);
    }
  }

  checkMySubmit() {
    try {
      axios.get(`${USER_API_URL}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`, { headers: { Pragma: 'no-cache' } }).then((res) => {
        this.setState({ myInfo: res.data.Item });
        console.log(res.data.Item);
      });
    } catch (e) {
      console.error(e);
    }
  }

  showQuiz(idx) {
    const quiz_start = moment('0800', 'HHmm').format('HHmm');
    const quiz_end = moment('1830', 'HHmm').format('HHmm');
    const todayTime = moment().format('HHmm');
    // if (this.state.myInfo && this.state.myInfo.isLeadership === 'Y') {
    // if (
    //   Number(this.state.now.getTime() >= Number(1603248600000) && Number(this.state.now.getTime()) < Number(1603254000000)) ||
    //   (Number(this.state.now.getTime()) >= Number(1603265400000) && Number(this.state.now.getTime()) < Number(1603292400000))
    // ) {
    // this.setState({ openQuiz: true, quizIdx: idx });
    if (todayTime >= quiz_start && todayTime <= quiz_end) {
      if (this.state.myInfo && this.state.myInfo['quiz_1']) {
        swal('', '이미 제출하셨습니다.', 'warning');
      } else {
        this.setState({ openQuiz: true, quizIdx: idx });
      }
    } else {
      swal('', '퀴즈 제출시간이 아닙니다.', 'warning');
    }
  }

  closeQuiz(idx, value) {
    // eslint-disable-next-line
    let buff = cloneDeep(this.state.myInfo);
    // eslint-disable-next-line
    let score = 0;
    if (value) {
      this.checkMySubmit();
    }
    this.setState({ openQuiz: false });

    // setTimeout(() => {
    //   this.setState({ openResult: true });
    // }, 500);
  }

  openResDialog = (event) => {
    this.setState({ openResult: true });
  };

  closeResDialog = (event) => {
    this.setState({ openResult: false });
  };

  render() {
    return (
      <Container style={window.matchMedia('(max-width:992px)').matches ? { margin: '40px 0' } : { height: '66vh' }}>
        <Grid container alignItems="center" style={{ height: '100%' }}>
          {this.state.ItemList.length > 0 &&
            this.state.ItemList.map((item, idx) => {
              // let tit = '퀴즈풀기';
              let tit = 'Quiz';
              return (
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="large"
                  key={idx}
                  onClick={() => {
                    this.showQuiz(item);
                  }}
                  style={{ padding: this.state.matches ? '4vh 0' : '2vh 0', fontSize: 'large' }}
                  startIcon={<BsPencilSquare size={40} />}
                >
                  <Grid>
                    <Grid container justifyContent="center">
                      <Typography>{tit}</Typography>
                    </Grid>
                    <Grid container justifyContent="center">
                      <Typography style={{ fontSize: 'small' }}> 문제풀이시간: 08:00~18:30</Typography>
                    </Grid>
                  </Grid>
                </Button>
              );
            })}
        </Grid>
        {this.state.datas && this.state.openQuiz ? (
          <QuizDialog
            open={this.state.openQuiz}
            onClose={this.closeQuiz}
            data={this.state.datas}
            quizIdx={this.state.quizIdx}
            quizCnt={this.state.quizCnt}
            userData={this.state.myInfo}
          />
        ) : (
          ''
        )}
        {this.state.myInfo && this.state.myInfo['quiz_1'] ? (
          <QuizResDialog
            open={this.state.openResult}
            onClose={this.closeResDialog}
            userData={this.state.myInfo}
            quizIdx={this.state.quizIdx}
            quizCnt={this.state.quizCnt}
            quizScore={this.state.quizScore}
          />
        ) : (
          ''
        )}
      </Container>
    );
  }
}

export default QuizButton;
